// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./AvatarTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS */

.Avatar-module__Container__Qoo3n {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--ds-avatar-text-color);
    font-weight: var(--ds-font-weight-bold);
}

.Avatar-module__Circle__jO2KU {
    flex-shrink: 0;
    border-radius: var(--ds-border-radius-circle);
}

.Avatar-module__Square__VxLo1 {
    flex-shrink: 0;
    border-radius: var(--ds-border-radius-s);
}

.Avatar-module__Small__HLnWp {
    width: var(--ds-l);
    height: var(--ds-l);
    font-size: var(--ds-font-size-xxs);
}

.Avatar-module__Medium__BJnQQ {
    width: var(--ds-xl);
    height: var(--ds-xl);
    font-size: var(--ds-font-size-s);
}

.Avatar-module__Bordered__zfrF7 {
    box-shadow: 0 0 0 var(--ds-05x) var(--ds-avatar-list-border-color) inset;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Avatar-module__Container__Qoo3n`,
	"Circle": `Avatar-module__Circle__jO2KU`,
	"Square": `Avatar-module__Square__VxLo1`,
	"Small": `Avatar-module__Small__HLnWp`,
	"Medium": `Avatar-module__Medium__BJnQQ`,
	"Bordered": `Avatar-module__Bordered__zfrF7`
};
export default ___CSS_LOADER_EXPORT___;
